
export const Footer = () => {
  return (
    <div className="bg-sky-300 h-28">
      
      <div className="bg-center">
      <img
              src="\LOGO_LETRAS_SHASAM_PNG.png"
              alt="logo"
              width="150"
              height="40"
              
              />
      <p className="text-dark-grayish-blue text-center [grid-area:copy]">Copyright Ⓒ 2024. All Rights Reserved</p>

      </div>
    </div>
  );
};